import { render, staticRenderFns } from "./SectionMenu.vue?vue&type=template&id=c1a5f6fc&lang=pug&"
import script from "./SectionMenu.vue?vue&type=script&lang=js&"
export * from "./SectionMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports